import React from "react";
import { PolyIcon } from "./PolyIcon";
import { Link } from "polyrouter";
import { AllQueryParam } from "polyrouter/allQueryParams";

export interface EdgeLinkProps {
  text: string;
  linkTo: string;
  keepParams?: Array<AllQueryParam>;
  onClose?: () => void;
}

export const EdgeLink: React.FC<EdgeLinkProps> = ({
  text,
  linkTo,
  keepParams,
  onClose
}) => {
  const doClose = () => {
    onClose && onClose();
  };

  return (
    <div className="edge-link" data-testid="edge-link">
      <div>
        <span
          className="edge-link-close"
          data-testid="close-edge-link"
          onClick={doClose}
        >
          <PolyIcon title="close" icon="clear_x" />
        </span>
        <div className="edge-link-content">
          <Link to={linkTo} persist={keepParams}>
            {text}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EdgeLink;
